import { render, staticRenderFns } from "./NewOpenAIChannel.vue?vue&type=template&id=9fd71a8e&scoped=true"
import script from "./NewOpenAIChannel.vue?vue&type=script&lang=js"
export * from "./NewOpenAIChannel.vue?vue&type=script&lang=js"
import style0 from "./NewOpenAIChannel.vue?vue&type=style&index=0&id=9fd71a8e&prod&lang=scss&scoped=true"
import style1 from "./NewOpenAIChannel.vue?vue&type=style&index=1&id=9fd71a8e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fd71a8e",
  null
  
)

export default component.exports